import { Mask, Toast } from 'antd-mobile';
import { useEffect, useMemo, useState } from 'react';
// import activity from '@/assets/images/activity.png';
// import centro from '@/assets/images/activity_bg.png';
// import activity_close from '@/assets/images/activity_close.png';
// import activity_button from '@/assets/images/activity_button.png';
// import yellowBox from '@/assets/images/yellowBox.png';
import rActivity from '@/assets/images/floating.gif';

import { useTranslation } from 'react-i18next';
import { formatter } from '@/utils/mathWays';
import {  useUserInfo } from '@/store';
import './index.less';
import { useActivate } from 'react-activation';
import { getUserInfo } from '@/tools';
import { useNavigate, useSearchParams } from 'react-router-dom';
import { getS3Url, prefetch } from '@/utils';

// 特殊活动的显示文案
const activityContent = {
  REMAIN: {
    Qualified: 'Disponível por tempo limitado',
    HasTask: 'Vá completar as tarefas'
  },
  PINDUODUO_REWARD: {
    Qualified: 'Pode participar do sorteio',
    HasTask: 'Vá completar as tarefas'
  },
  RED_ENVELOPE_RAIN: {
    Qualified: 'Pode receber o prêmio'
  }
};

// prefetch('/images/b3b.png', 'image/png', 'image');

// 活动可领取奖励弹窗
const ActivityPop = ({ allConfigList }) => {
  const { t } = useTranslation();
  const { getToken } = getUserInfo();
  const [searchParams] = useSearchParams();
  const navigate = useNavigate();

  const [showList, setShowList] = useState(() =>
    allConfigList?.filter(
      item =>
        // item?.claimStatus === 'Qualified' ||
        // item?.claimStatus === 'HasTask' ||
        (item?.activityType === 'RED_ENVELOPE_RAIN' &&
          item?.claimStatus === 'Qualified') ||
        item?.claimableAmount > 0
    )
  );
  const [visible, setVisible] = useState(false);

  useActivate(() => {
    if (allConfigList.length) {
      const list = allConfigList?.filter(
        item =>
          // item?.claimStatus === 'Qualified' ||
          // item?.claimStatus === 'HasTask' ||
          (item?.activityType === 'RED_ENVELOPE_RAIN' &&
            item?.claimStatus === 'Qualified') ||
          item?.claimableAmount > 0
      );
      setShowList(list);
      setVisible(list.length > 0);
    }
    // const newParams = new URLSearchParams(searchParams);
    // newParams.set('pp', '88');
    //  console.log(
    //    '%c [ newParams ]-76',
    //    'font-size:13px; background:pink; color:#bf2;',
    //    newParams.toString()
    //  );
  });

  // 跳转活动
  const handleJump = async (activityType, link, id) => {
    const newParams = new URLSearchParams(searchParams);
    newParams.set('activityId', id);
    navigate(`${link}?${newParams.toString()}`);
  };

  useEffect(() => {
    if (allConfigList.length) {
      const list = allConfigList?.filter(
        item =>
          // item?.claimStatus === 'Qualified' ||
          // item?.claimStatus === 'HasTask' ||
          (item?.activityType === 'RED_ENVELOPE_RAIN' &&
            item?.claimStatus === 'Qualified') ||
          item?.claimableAmount > 0
      );
      setShowList(list);
      setVisible(list.length > 0);
    }
  }, [allConfigList]);

  return (
    <>
      {showList.length > 0 && (
        <div className="fixed right-4 bottom-[150px] z-5">
          <img
            className="w-[86px] h-[86px]  "
            src={rActivity}
            onClick={() => {
              setVisible(true);
            }}
            alt=""
          />
          <i className="w-3 h-3 rounded-full bg-[#EE0A24] absolute top-1 right-2" />
        </div>
      )}
      {/* background: linear-gradient(180deg, #2B124C 0%, #2B124C 100%);
       */}
      <Mask visible={visible} className="activity-content">
        <div className="activityRecompensa relative mt-[-30px]">
          <img className="w-[100%]" src='/images/b3b.png' />

          <div className="activityCon">
            <img
              className="w-[240px] h-[72px] block mx-auto"
              src={getS3Url('home/b4.png')}
            />

            <img
              onClick={() => {
                setVisible(false);
              }}
              src={getS3Url('home/i_10.png')}
              className="w-10 h-10 absolute left-[50%] bottom-[-70px] ml-[-20px]"
            />
            <div className="mt-4 mx-[10px] flex flex-col gap-3 max-h-[208px] overflow-y-scroll">
              {showList.length > 0
                ? showList.map(
                    ({
                      menuLogo,
                      claimableAmount,
                      activityType,
                      claimStatus,
                      link,
                      id,
                      customName,
                      defaultName
                    }) => (
                      <div className="acItem flex items-center gap-2" key={id}>
                        <img
                          className="w-[36px] h-[36px] ml-3"
                          src={menuLogo}
                          alt=""
                        />
                        <div className="flex-1 flex flex-col items-start justify-center  text-[#fff] ">
                          {/* {activityContent[activityType] && ( */}
                            <p className="text-sm leading-3 pb-1 text-[#FFDF12] truncate w-[170px]">
                              {customName || defaultName}
                            </p>
                          {/* )} */}
                          {/* <p className="text-sm leading-3 pb-1">Bônus</p> */}
                          {/* {claimableAmount > 0 ? (
                            <p className="text-sm leading-3 pb-1">Bônus</p>
                          ) : null} */}
                          {claimableAmount > 0 ? (
                            <p className="text-[15px] font-[600] leading-5">
                              {formatter.format(claimableAmount)}{' '}
                              <span className="text-[11px] font-[400]">R$</span>
                            </p>
                          ) : null}
                        </div>
                        {/* <button
                        onClick={() => {
                          handleJump(activityType, link, id);
                        }}
                        className="w-[90px] h-[62px] font-[600] text-base bg-gradient-to-br from-[#FCD7A1] to-[#D17836] text-[#422E00] rounded-[8px]"
                      >
                        Claim Now
                      </button> */}
                        <img
                          src={getS3Url('home/b6.png')}
                          className="w-[82px] mr-3 mt-[5px]"
                          onClick={() => {
                            handleJump(activityType, link, id);
                          }}
                        />
                      </div>
                    )
                  )
                : null}
            </div>
          </div>
        </div>
      </Mask>
    </>
  );
};

export default ActivityPop;
